import {useEffect, useState} from "react";
import httpService from "../../services/httpService";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import { FaRegCircleCheck } from "react-icons/fa6";
import { FaSpinner } from "react-icons/fa6";
import {Modal} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import EpisodeModalComponent from "./EpisodeModalComponent";
import { FaLightbulb } from "react-icons/fa";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Form from "react-bootstrap/Form";

const EpisodeSelectCard = ({ episode, onEpisodeSelected, podcastClubGuid, clubEpisodes }) => {
    const [saving, setSaving] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSelected, setIsSelected] = useState(false);

    useEffect(() => {
        clubEpisodes.map(c_e => {
            console.log(c_e)
            console.log(episode)
            if(c_e.id === episode.id){
                setIsSelected(true);
            }
        })
    }, [clubEpisodes]);

    const editEpisode = async () => {
        handleShow(true)
    }

    const handleOpenEpisode = (episode) => {
        handleShow();
    }

    const handleClose = () => {
        setModalShow(false)
        // reload episodes
        onEpisodeSelected()
    };
    const handleShow = () => {
        setModalShow(true)
    };

    return(
        <div>
            <Card style={{ borderLeft: '10px solid '+ episode.pivot.color}} className={`p-3 mb-3 episode-card edit`}>
                <Row>
                    <Col sm={8}>
                        <p>{episode.title}</p>
                    </Col>
                    <Col sm={1} className={`text-center ${episode.key_takeaways_count === 0 ? 'text-primary' : 'text-success'}`}>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip>
                                    Number of Actionable Insights {episode.key_takeaways_count === 0 ? ', must be greater than 1' : ''}
                                </Tooltip>
                            }
                        >
                            <span>
                                <FaLightbulb /> {episode.key_takeaways_count}
                            </span>
                        </OverlayTrigger>
                    </Col>
                    <Col sm={3}>
                        <Button onClick={editEpisode} disabled={saving} className="w-100" variant="light">
                            {episode.key_takeaways_count === 0 ? "Add Insights" : "Edit Insights"}
                        </Button>
                    </Col>
                </Row>
            </Card>
            <Modal
                size={"lg"}
                show={modalShow}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton style={episode.pivot.color ? { borderTop: '10px solid '+ episode.pivot.color } : {}}>
                    {/*<Modal.Title>Edit episode</Modal.Title>*/}
                </Modal.Header>
                <Modal.Body>
                    <EpisodeModalComponent episode={episode} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={handleClose}>
                        Close
                    </Button>
                    {/*<Button variant="primary">Save</Button>*/}
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default EpisodeSelectCard;